import { Message, useMessage } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { ReactComponent as Image053 } from '../images/OP_symbolikuvitus_128_053.svg';

interface Props {
  messageId: string;
}

const CourseComplete = (props: Props): JSX.Element => {
  const { messageId } = props;
  const messageArray = useMessage(`${messageId}.body`);

  return (
    <div>
      <Image053
        className="investoracademy-small-svg"
        style={{
          marginTop: space.xxl,
        }}
        aria-hidden="true"
      />
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', paddingTop: space.default }}
      >
        <Message id={`${messageId}.title`} />
      </h2>
      {Object.keys(messageArray).map((index, value) => {
        return (
          <div
            key={index}
            className="opds-styles-v1-text-body-medium"
            style={{ textAlign: 'center', paddingTop: space.default }}
          >
            <Message id={`${messageId}.body.body${value + 1}`} />
          </div>
        );
      })}
    </div>
  );
};

export default CourseComplete;
